import * as React from "react";
import { DM_DataSheet } from "../models/DM_DataSheet";
import { ClickedDeviceInfo } from "../models/clickedDeviceInfo";

interface Props {
  text: string;
  liClassName: string;
  ulClassName: string;
  devices?: DM_DataSheet[];
  selectedDevice?: ClickedDeviceInfo;
  type: "Input" | "Action";
  onDeviceClick: (deviceId: string, deviceType: "DEVICE" | "LS" | "SS", dataSheetId?: number) => void;
  onDeviceRightClick: (e: React.MouseEvent, deviceType: "DEVICE" | "LS" | "SS", deviceId: string, dataSheetId?: number) => void;
  searchPattern: string;
}
interface State {
  expanded: boolean;
}

const liStyle: React.CSSProperties = {
  cursor: "pointer",
  color: "black"
};

export class DeviceSubGroup extends React.Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      expanded: false
    };
  }

  expandUpdate = () => {
    if (!this.props.searchPattern) {
      this.setState({ expanded: !this.state.expanded });
    }
  }

  renderList() {

    const orderedDevices = this.props.devices.sort((d1, d2) => d1.inputVisibleOrder - d2.inputVisibleOrder);
    const deviceSelected = this.props.selectedDevice && !this.props.selectedDevice.deviceDataSheetId
      && !this.props.selectedDevice.logicSolverSheetId
      && !this.props.selectedDevice.supportSheetId;
    return <ul className={this.props.ulClassName} style={{ overflow: "hidden" }}>
      {orderedDevices.map((d) => {
        const description = this.props.type === "Input"
          ? d.inputDescription
          : d.actionDescription

        return (
          <li key={d.deviceId}
            style={liStyle}
            className={deviceSelected && d.deviceId === this.props.selectedDevice.deviceId ? "selected-device" : ''}>
            <div
              className={d.deviceId}
              onClick={e => this.props.onDeviceClick(d.deviceId, "DEVICE", d.dataSheetId)}
              draggable
              onDrag={() => this.props.onDeviceClick(d.deviceId, "DEVICE", d.dataSheetId)}
            >
              <img src={`/HTMLImages/Device/${d.deviceId}.bmp`} onContextMenu={e => this.props.onDeviceRightClick(e, "DEVICE", d.deviceId)} />
            </div>
            <label className="label1">{description}</label>
          </li>
        )
      })}
    </ul>
  }

  render() {


    return (
      <div>
        <li className={this.props.liClassName} onClick={this.expandUpdate} style={{ backgroundColor: "rgb(184, 184, 184)", ...liStyle }}>{this.props.text}</li>
        {(this.props.searchPattern || this.state.expanded) && this.renderList()}
      </div>
    );
  }
}

export default DeviceSubGroup;